export const mockS3Prefixes = {
  historyImages: 'history/images',
  certificationImages: 'certification/images',
  catalogPreviewImages: 'catalog/preview-images',
  catalogDetailImages: 'catalog/detail-images',
  promoVideoThumbnails: 'promo-videos/thumbnails',
  promoVideoSources: 'promo-videos/videos',
} as const;

export const buildMockStorageKey = (
  prefix: (typeof mockS3Prefixes)[keyof typeof mockS3Prefixes],
  fileName: string,
) => {
  return `${prefix}/${fileName}`;
};
